(ns renolit-roofing-service.mobile
  (:require [re-frame.core :as rf]))

(def ^:const ^:private max-mobile-width 768)

(rf/reg-event-db
 ::set-mobile
 (fn [db [_ _]]
   (assoc db :mobile? true)))

(rf/reg-event-db
 ::set-desktop
 (fn [db [_ _]]
   (dissoc db :mobile?)))

(rf/reg-sub
 ::mobile?
 ^:clj-kondo/ignore
 (fn [db]
   (:mobile? db)))

(defn- mobile? []
  (<= (.-innerWidth js/window) max-mobile-width))

(defn set-device []
  (if (mobile?)
    (rf/dispatch [::set-mobile])
    (rf/dispatch [::set-desktop])))

(defn add-resize-listener []
  (set-device)
  (.addEventListener js/window
                     "resize"
                     set-device))